// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainLayout_main-layout-search-block__e3b1y {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
}
.MainLayout_main-layout-search-block__e3b1y.MainLayout_main-layout-search-block__added-padding__WFjrJ {
  padding: 0 12.5px;
}
.MainLayout_main-layout-search-block__e3b1y .searchBlock {
  margin-top: 0;
}
.MainLayout_main-layout-search-block__QR-btn__uzI0I {
  display: flex;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.MainLayout_main-layout-search-block__QR-btn__uzI0I svg {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
}
@media (min-width: 640px) {
  .MainLayout_main-layout-search-block__QR-btn__uzI0I {
    width: 40px;
    height: 40px;
  }
}
@media (min-width: 640px) {
  .MainLayout_main-layout-search-block__e3b1y {
    gap: 16px;
    margin-top: 16px;
  }
}
@media (min-width: 1200px) {
  .MainLayout_main-layout-search-block__e3b1y {
    gap: 16px;
    margin-top: 0;
  }
}

.MainLayout_titleObj__wxskw,
.MainLayout_techObj__bi00i {
  margin-bottom: 16px;
}

.MainLayout_empty-text__KBPGZ {
  font-size: 16px;
  font-weight: 600;
  line-height: 18.24px;
  text-align: left;
}
@media (max-width: 1200px) {
  .MainLayout_empty-text__KBPGZ {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: initial;
    text-align: center;
  }
}
@media (max-width: 768px) {
  .MainLayout_empty-text__KBPGZ {
    max-width: 190px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MainLayout/MainLayout.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AACF;AACE;EACE,iBAAA;AACJ;AAGI;EACE,aAAA;AADN;AAKE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAHJ;AAKI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAHN;AAMI;EAbF;IAcI,WAAA;IACA,YAAA;EAHJ;AACF;AAME;EAnCF;IAoCI,SAAA;IACA,gBAAA;EAHF;AACF;AAKE;EAxCF;IAyCI,SAAA;IACA,aAAA;EAFF;AACF;;AAKA;;EAEE,mBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AAFF;AAIE;EANF;IAOI,kBAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IACA,eAAA;IACA,kBAAA;EADF;AACF;AAGE;EAfF;IAgBI,gBAAA;EAAF;AACF","sourcesContent":[".main-layout-search-block {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 24px;\n\n  &.main-layout-search-block__added-padding {\n    padding: 0 12.5px;\n  }\n\n  :global {\n    .searchBlock {\n      margin-top: 0;\n    }\n  }\n\n  &__QR-btn {\n    display: flex;\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n\n    svg {\n      width: 100%;\n      height: 100%;\n      max-width: 100%;\n      max-height: 100%;\n    }\n\n    @media (min-width: 640px) {\n      width: 40px;\n      height: 40px;\n    }\n  }\n\n  @media (min-width: 640px) {\n    gap: 16px;\n    margin-top: 16px;\n  }\n\n  @media (min-width: 1200px) {\n    gap: 16px;\n    margin-top: 0;\n  }\n}\n\n.titleObj,\n.techObj {\n  margin-bottom: 16px;\n}\n\n.empty-text {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 18.24px;\n  text-align: left;\n\n  @media (max-width: 1200px) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    margin: initial;\n    text-align: center;\n  }\n\n  @media (max-width: 768px) {\n    max-width: 190px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main-layout-search-block": `MainLayout_main-layout-search-block__e3b1y`,
	"main-layout-search-block__added-padding": `MainLayout_main-layout-search-block__added-padding__WFjrJ`,
	"main-layout-search-block__QR-btn": `MainLayout_main-layout-search-block__QR-btn__uzI0I`,
	"titleObj": `MainLayout_titleObj__wxskw`,
	"techObj": `MainLayout_techObj__bi00i`,
	"empty-text": `MainLayout_empty-text__KBPGZ`
};
export default ___CSS_LOADER_EXPORT___;
